import { AmrClass } from '../amr-pipeline/models/AmrClass';
import { AmrTransaction } from '../amr-pipeline/models/AmrTransaction';
import { OriginatingTransaction } from '../amr-pipeline/models/OriginatingTransaction';
import { OriginatingTransactionClass } from '../amr-pipeline/models/OriginatingTransactionClass';
import { SyndicateContacts } from '../amr-pipeline/models/SyndicateContacts';
import { Company } from "../amr-pipeline/models/Company";
import { TransactionsStatistics } from '../amr-pipeline/models/TransasctionsStatistics';
import { TransactionClassesStatistics } from '../amr-pipeline/models/TransactionClassesStatistics';
import { KMatrix } from '../amr-pipeline/models/K-MatrixResponse';
import { RequestState } from '../../constants/request-state';

export interface AmrDealsState {
    transactions?: Array<OriginatingTransaction | AmrTransaction>;
    classes?: Array<OriginatingTransactionClass | AmrClass>;
    kMatrix?: KMatrix[];
    transactionsStatistic?: TransactionsStatistics;
    classesStatistic?: TransactionClassesStatistics;
    summaryRequestState?: RequestState;
    classesOffset: number;
    transactionsOffset: number;
    kMatrixOffset: number;
    numberOfHiddenTransactions?: number;
    numberOfHiddenClasses?: number;
    numberOfHiddenKMatrix?: number;
    isTransactionsSearching: boolean;
    isClassesSearching: boolean;
    isKMatrixSearching: boolean;
    syndicateContacts: SyndicateContacts | null;
    isManagerPopupVisible: boolean;
    dealSortBy?: string;
    dealSortDirection?: string;
    classSortBy?: string;
    classSortDirection?: string;
    kMatrixSortBy?: string;
    kMatrixSortDirection?: string;
    kMatrixViewType: KMatrixViewType;
    kMatrixViewTypeAutoChange?: boolean;
    isExpanded: boolean;
    hasMoreTransactions: boolean;
    hasMoreTransactionsClasses: boolean;
    hasMoreKMatrix: boolean;
    userCompany?: Company;
    wasInitialAccessTracked: boolean;
    isExportLoad: boolean;
    anyIOIsExists: boolean;
    totalKMatrixClassItemsCount: number;
}

export enum KMatrixViewType {
    Default = 'Default',
    MVOC = 'MVOC',
    CE = 'CE'
}
